import { render, staticRenderFns } from "./StudentsSelect.vue?vue&type=template&id=58ca4962&"
import script from "./StudentsSelect.vue?vue&type=script&lang=js&"
export * from "./StudentsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports